import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isAnalyticsEnabled } from "../analytics/isAnalyticsEnabled";

/**
 * SPA route changes → Umami page view (pathname).
 */
export function useUmami() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || !isAnalyticsEnabled()) return;
    const umami = window.umami;
    if (umami && typeof umami.trackView === "function") {
      try {
        umami.trackView(pathname);
      } catch {
        /* no-op */
      }
    }
  }, [pathname]);
}
